var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Topo',{attrs:{"btnLogout":true,"acessoRestritoMenu":true}}),_c('Migalha',{attrs:{"label":"Área Restrita"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }